<div class="email-title text-center lh24"><b>{{ userEmail }}</b></div>
<div class="text-center margin-top mt8 margin-bottom mb24 lh24">
  {{ 'ALL_READY_IN_USE' | translate }}
</div>
<div class="text-center">
  <mapfre-button 
    additionalClasses="basic primary large-btn margin-bottom mb24"
    [routerLink]="['/login']"> 
    {{ 'LOG_INTO_ACCOUNT' | translate }} 
  </mapfre-button>
  <mapfre-button 
    additionalClasses="ghost secondary large-btn"
    [routerLink]="['/signup']"> 
    {{ 'CREATE_NEW_ACCOUNT' | translate }} 
  </mapfre-button>
</div>
<hr class="margin-vertical mv24" />
<div class="text-center">
  {{ 'IF_YOU_DONT_REMEMBER' | translate }}
</div>